import {AxiosError} from "axios";
import {uploadReplacer} from "../../../4-upload-results/uploadReplacer.ts";

export function errorText(e: unknown): string {
    if(e instanceof AxiosError) {
        if(e.response) {
            const data = e.response?.data
            const status = e.response.status.toString()
            const statusText = e.response.statusText
            let message: string = "Unknown error - Check network tab for details"
            if (data) {
                if (typeof (data) === "string") {
                    message = data
                } else if (typeof (data) === "object" && !Array.isArray(data)) {
                    message = data["message"] ?? data["msg"] ?? JSON.stringify(data, uploadReplacer)
                }
            }
            return `[${status} | ${statusText}] ${message}`
        }
    }
    if(e instanceof Error) {
        return e.message ?? "Unknown error"
    }
    return "Unknown error"
}